import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import logoEn from '../../assets/images/logo_en.png';
import logoFr from '../../assets/images/logo_fr.png';
import home from '../../assets/images/home.png';

const Header = () => {
  const { i18n, t } = useTranslation();

  const { pathname } = useLocation();
  const isHomeBtnActive =
    pathname === '/instruction' ||
    pathname === '/data-entry' ||
    pathname === '/data-entry-mobile' ||
    pathname === '/quiz';

  const navigate = useNavigate();

  const goHome = async () => {
    navigate('/');
  };

  return (
    <header className="w-full relative z-20">
      <div className="px-10 sm:py-8 py-6">
        <img src={i18n.language === 'en' ? logoEn : logoFr} alt="logo" className="w-full" />
      </div>

      {isHomeBtnActive && (
        <button className="md-size-10 lg:size-12 size-6 absolute right-[85%]" onClick={goHome}>
          <img src={home} alt="home" />
        </button>
      )}

      <button
        className="md:text-2xl text-[0.6rem] sm:px-4 p-2 border rounded-sm absolute sm:left-[82%] md:left-[78%] left-[78%]"
        onClick={() => (i18n.language === 'en' ? i18n.changeLanguage('fr') : i18n.changeLanguage('en'))}
      >
        <span>{t('lang')}</span>
      </button>

      <div className="sm:text-[3.8rem] lg:text-[7.2rem] text-[2rem] font-bold leading-[1.1] text-center sm:mt-20 mt-[2.8rem]">
        <h1>{t('cta1a')}</h1>
        <h1>{t('cta1b')}</h1>
      </div>
    </header>
  );
};

export default Header;
